// mini-profiler.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
 import { environment } from 'src/environments/environment';


declare const MiniProfiler:
  | {
    container?: HTMLElement;
    fetchResults(ids: string[]): void;
  }
  | undefined;


@Injectable({
  providedIn: 'root'
})
export class MiniProfilerService {
  private readonly ERROR_MESSAGE = 'MiniProfiler could not be loaded: ';

  private readonly INCLUDE_URL = '/api/HealthCheck/MiniProfilerIncludes';

  private webApiURL = '';
  constructor(private http: HttpClient) { }

  init(): void {
    if ((<any>window).MiniProfiler) {
      console.warn('MiniProfiler already imported.');
      return;
    }
    this.webApiURL = environment.apiServer.webApiURL;
    if (this.webApiURL.endsWith('/api'))
      this.webApiURL = this.webApiURL.substr(0, this.webApiURL.length - 4);
    
    this.getIncludes()
      .then(scriptHtml => {
        if (scriptHtml) {
          this.loadScript(scriptHtml);
        }
      })
      .catch(err => {
        console.error(this.ERROR_MESSAGE + err);
      });
  }

  clear(): void {
    if (typeof MiniProfiler !== 'undefined' && MiniProfiler.container) {
      const clearButton = MiniProfiler.container.querySelector<HTMLSpanElement>(
        '.mp-controls .mp-clear',
      );
      if (clearButton) {
        //console.debug(`MiniProfiler clear`);
        clearButton.click();
      }
    }
  }
  fetch(ids: string[]): void {
    if (typeof MiniProfiler !== 'undefined') {
      //console.debug(`MiniProfiler fetch`, MiniProfiler);
      MiniProfiler.fetchResults(ids);
    }
  }

  private getIncludes(): Promise<string | undefined> {
    return this.http.get(this.webApiURL + this.INCLUDE_URL, { responseType: 'text' }).toPromise();
  }

  private loadScript(scriptHtml: string): void {
    if (!('DOMParser' in window)) {
      console.error(this.ERROR_MESSAGE + 'DOMParser not supported');
      return;
    }

    try {
      const parser = new DOMParser();
      const doc = parser.parseFromString(scriptHtml, 'text/html');
      const scriptParsed = doc.querySelector('script');

      if (!scriptParsed) return;

      const script = document.createElement('script');
      for (var i = 0; i < scriptParsed.attributes.length; i++) {
        const attr = scriptParsed.attributes[i];
        if (attr.name == 'src' || attr.name == 'data-path')
          script.setAttribute(attr.name, this.webApiURL + attr.value);
        else // if (attr.name != 'data-current-id' && attr.name != 'data-ids')
          script.setAttribute(attr.name, attr.value);
      }

      const target = document.getElementsByTagName('script')[0];
      target.parentNode?.insertBefore(script, target);
    } catch (err) {
      console.error(this.ERROR_MESSAGE + err.toString());
    }
  }
}
